<template>
    <div>
        <tb-skeleton v-if="!initialized" :height="100" :theme="'opacity'" :shape="'radius'" bg-color="#dcdbdc"></tb-skeleton>

        <div v-else-if="not_found">
            <i>Användaren finns inte</i>
        </div>
        <div v-else-if="initialized">
            <div class="form-group d-flex flex-row">
                <div class="col-form-label mr-2">Datumintervall:</div>
                <div style="width: 250px;">
                    <v-date-picker v-model="workhours_from" mode="date" :model-config="{ type: 'string', mask: 'YYYY-MM-DD' }" :masks="{ input: 'YYYY-MM-DD' }">
                        <template v-slot="{ inputValue, togglePopover }">
                            <input class="form-control" :value="inputValue" @focus="togglePopover()">
                        </template>
                    </v-date-picker>
                </div>
                <div style="padding: 0 10px; line-height: 36px;">&mdash;</div>
                <div style="width: 250px;">
                    <v-date-picker v-model="workhours_to" mode="date" :model-config="{ type: 'string', mask: 'YYYY-MM-DD' }" :masks="{ input: 'YYYY-MM-DD' }">
                        <template v-slot="{ inputValue, togglePopover }">
                            <input class="form-control" :value="inputValue" @focus="togglePopover()">
                        </template>
                    </v-date-picker>
                </div>
            </div>
            <div class="row">
                <div class="col-xl-12">
                    <table class="table table-striped table-xs">
                        <thead>
                            <tr>
                                <th>Börjat</th>
                                <th>Slutat</th>
                                <th style="text-align:right;">Rapporterad tid</th>
                                <th style="text-align:right;">Rast(m)</th>
                                <th style="text-align:right;">Arbetad tid</th>
                            </tr>
                        </thead>
                        <tbody>
                            <tr v-for="(time, t_idx) in workhours" :key="'t-' + t_idx" :style="{ 'color': (time.PayslipID>0 ? '#999999' : 'inherit') }">
                                <td>{{ formatDateTime(time.TimeIN) }} {{ getDayName(time.TimeIN) }}</td>
                                <td>{{ formatDateTime(time.TimeOUT) }}</td>
                                <td style="text-align:right;">
                                    {{ (Math.round(parseFloat(time.TotalTime) * 100) / 100).toLocaleString('sv-SE', { minimumFractionDigits: 2, maximumFractionDigits: 2 }) }}
                                </td>
                                <td style="text-align:right;">
                                    {{ (Math.round(parseFloat(time.BreakMinutes) * 100) / 100).toLocaleString('sv-SE', { minimumFractionDigits: 2, maximumFractionDigits: 2 }) }}
                                </td>
                                <td style="text-align:right;" :style="{ 'color': (time.SickLeave ? 'red' : 'inherit') }">
                                    {{ (Math.round(parseFloat(time.WorkedTime) * 100) / 100).toLocaleString('sv-SE', { minimumFractionDigits: 2, maximumFractionDigits: 2 }) }}
                                </td>
                            </tr>
                        </tbody>
                        <tfoot>
                            <tr>
                                <th colspan="4" style="text-align:right;">Totalt arbetade timmar:</th>
                                <th colspan="1" style="text-align:right;">{{ workhours_total }}</th>
                            </tr>
                        </tfoot>
                    </table>
                </div>
            </div>
        </div>
        <div v-else>
            <i>Något gick fel...</i>
        </div>
    </div>
</template>

<script>
import apiClient from '@services/ApiClient';
import VDatePicker from 'v-calendar/lib/components/date-picker.umd';
import { formatDateTime, getDayName } from '@services/Helpers';

export default {
    name: 'UserEdit',
    components: {
        VDatePicker,
    },
    props: {
        id: {
            type: [String, Number],
            default: '',
        },
    },
    data: () => ({
        initialized: false,
        busy_loading: false,
        not_found: false,
        user: null,
        workhours_from: '',
        workhours_to: '',
        workhours: [],
    }),
    mounted() {
        const firstDayOfMonth = new Date();
        firstDayOfMonth.setDate(1);

        const lastDayOfMonth = new Date(firstDayOfMonth.getFullYear(), firstDayOfMonth.getMonth() + 1, 0);
        this.workhours_from = firstDayOfMonth.getFullYear() + '-' + (firstDayOfMonth.getMonth() + 1).toString().padStart(2, '0') + '-' + firstDayOfMonth.getDate().toString().padStart(2, '0');
        this.workhours_to = lastDayOfMonth.getFullYear() + '-' + (lastDayOfMonth.getMonth() + 1).toString().padStart(2, '0') + '-' + lastDayOfMonth.getDate().toString().padStart(2, '0');
        this.getWorkhours();
    },
    watch: {
        workhours_to() {
            this.getWorkhours();
        },
        workhours_from() {
            this.getWorkhours();
        },
    },
    methods: {
        getDayName,
        formatDateTime,
        async getWorkhours() {
            if (this.id > 0) {
                await apiClient.get('/vue/users/' + this.id + '/timecares?cause_code=arb&date_from=' + this.workhours_from + '&date_to=' + this.workhours_to)
                    .then((response) => {
                        this.workhours = response.data.timecares;
                    })
                    .catch((error) => {
                        const { status } = error.response;
                        if (status === 404) {
                            this.not_found = true;
                        }
                    })
                    .finally(() => {
                        this.initialized = true;
                    });
            }
        },
    },
    computed: {
        workhours_total() {
            const reducer = (previousValue, time) => previousValue + (Math.round(parseFloat(time.WorkedTime) * 100) / 100);
            return (Math.round(this.workhours.reduce(reducer, 0) * 100) / 100).toLocaleString('sv-SE', { minimumFractionDigits: 2, maximumFractionDigits: 2 });
        },
    },
};

</script>
